/**
 * Created by richard on 5/8/14.
 */
var parentApp = angular.module('parentApp', ['classy', 'addendumLetter', 'appealsSettings', 'gradeSetup',
    'askSchoolSpecificQuestions', 'systemStatus', 'ui.bootstrap', 'applicationDeadline', 'language', 
    'appealsQuestions']);
parentApp.classy.controller({
    name: 'ParentAppController',
    inject: ['$scope',  'authServiceFactory', 'ModelService'],
    init: function()
    {
        this.$.auth = this.authServiceFactory.getAuth();
        this.$.activeSection = 'parentApp';
        this.$.versionNo = versionNo;   
    }
});



stateProviders.push({
    name: 'schoolside.settings.parentApp',
    url: '/parentApp',
    templateUrl: 'fast/submodules/schoolside/settings/parentApp/parentApp.html?v=' + versionNo,
    controller: 'ParentAppController'
});

